import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'ai.vivascore.patientnavigator',
  appName: 'Patient Navigator',
  webDir: 'www',
  loggingBehavior: 'production',

  server: {
    errorPath: '/'
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: true,
      launchShowDuration: 10000,
      androidSplashResourceName: "splash",
      androidScaleType: "FIT_CENTER",
      backgroundColor: "#f6f5f9",
      splashFullScreen: true,
      splashImmersive: true,
      useDialog: false
    },
    Keyboard: {
      resizeOnFullScreen: true
    }
  },

  ios: {
    scheme: 'patientnavigator',
    handleApplicationNotifications: false
  },

  android: {
    flavor: 'patientnavigator',
    loggingBehavior: 'none'
  }
};

export default config;
